import React from 'react';
import cn from 'classnames';
import { TableSortDirectionArrowDescSvg } from 'apps/sigma2-ui/src/components/svg/TableSortDirectionArrowDesc';
import { TableSortDirectionArrowAscSvg } from 'apps/sigma2-ui/src/components/svg/TableSortDirectionArrowAsc';
import { SortDirection } from 'libs/end-to-end/src/ui-types';

export const TableSortingIcon: React.FC<{
  direction: SortDirection;
  isActive: boolean;
}> = ({ direction, isActive }) => {
  const color = isActive ? 'text-gray-900' : 'text-gray-400';

  if (direction === 'desc') {
    return (
      <TableSortDirectionArrowDescSvg
        svg={{ className: cn('h-4', color) }}
        wantsCurrentColor
      />
    );
  }

  return (
    <TableSortDirectionArrowAscSvg
      svg={{ className: cn('h-4', color) }}
      wantsCurrentColor
    />
  );
};
